// baseInviteRedirectStorage.js

const INVITE_TOKEN_KEY = 'orbital.pendingBaseInviteToken';
const POST_AUTH_REDIRECT_KEY = 'orbital.postAuthRedirect';

function canUseStorage(storage) {
  return typeof window !== 'undefined' && Boolean(storage);
}

export function readPendingBaseInviteToken() {
  if (!canUseStorage(window.localStorage)) return '';

  try {
    return String(window.localStorage.getItem(INVITE_TOKEN_KEY) || '').trim();
  } catch (error) {
    console.warn('[baseInviteRedirectStorage] unable to read invite token:', error);
    return '';
  }
}

export function writePendingBaseInviteToken(token) {
  const normalized = String(token || '').trim();
  if (!normalized || !canUseStorage(window.localStorage)) return;

  try {
    window.localStorage.setItem(INVITE_TOKEN_KEY, normalized);
  } catch (error) {
    console.warn('[baseInviteRedirectStorage] unable to store invite token:', error);
  }
}

export function clearPendingBaseInviteToken() {
  if (!canUseStorage(window.localStorage)) return;

  try {
    window.localStorage.removeItem(INVITE_TOKEN_KEY);
  } catch (error) {
    console.warn('[baseInviteRedirectStorage] unable to clear invite token:', error);
  }
}

export function readStoredPostAuthRedirect() {
  if (!canUseStorage(window.localStorage)) return null;

  try {
    const path = String(window.localStorage.getItem(POST_AUTH_REDIRECT_KEY) || '').trim();
    return path || null;
  } catch (error) {
    console.warn('[baseInviteRedirectStorage] unable to read post-auth redirect:', error);
    return null;
  }
}

export function writeStoredPostAuthRedirect(path) {
  const normalized = String(path || '').trim();
  if (!normalized || !canUseStorage(window.localStorage)) return;

  try {
    window.localStorage.setItem(POST_AUTH_REDIRECT_KEY, normalized);
  } catch (error) {
    console.warn('[baseInviteRedirectStorage] unable to store post-auth redirect:', error);
  }
}

export function clearStoredPostAuthRedirect() {
  if (!canUseStorage(window.localStorage)) return;

  try {
    window.localStorage.removeItem(POST_AUTH_REDIRECT_KEY);
  } catch (error) {
    console.warn('[baseInviteRedirectStorage] unable to clear post-auth redirect:', error);
  }
}

export function captureInviteTokenFromSearch(search = '') {
  const token = String(new URLSearchParams(search).get('token') || '').trim();
  if (token) {
    writePendingBaseInviteToken(token);
  }
  return token;
}
